import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';
import { clsx } from 'clsx';
import { type ButtonAffixIconPosition, type ButtonAppearance, ButtonContent, type ButtonSize, type ButtonState, type ButtonVariant } from './shared';
import styles from './button.module.scss';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  affixIcon?: ReactNode;
  affixIconPosition?: ButtonAffixIconPosition;
  appearance?: ButtonAppearance;
  className?: string;
  contentClassName?: string;
  fullWidth?: boolean;
  ref?: Ref<HTMLButtonElement>;
  size?: ButtonSize;
  state?: ButtonState;
  variant?: ButtonVariant;
}

export function Button({
  affixIcon,
  affixIconPosition = 'left',
  appearance,
  className,
  children,
  contentClassName,
  disabled,
  fullWidth,
  size = 'medium',
  state = 'initial',
  variant = 'primary',
  ...rest
}: ButtonProps) {
  return (
    <button
      className={clsx(
        styles.button,
        styles[`variant-${variant}`],
        styles[`size-${size}`],
        styles[`state-${state}`],
        styles[`appearance-${appearance}`],
        Boolean(affixIcon) && styles[`affix-${affixIconPosition}`],
        Boolean(affixIcon && !children) && styles.iconOnly,
        fullWidth && styles.fullWidth,
        className,
      )}
      disabled={disabled || state === 'loading'}
      type="button"
      {...rest}
    >
      <ButtonContent affixIcon={affixIcon} affixIconPosition={affixIconPosition} className={contentClassName} state={state}>
        {children}
      </ButtonContent>
    </button>
  );
}
